import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {TypeAssistancesCategories} from '../../../../../domain/assistance/model/type-assistances-categories';
import {ImportanceCategories} from '../../../../../domain/assistance/model/importance-categories';
import {Sort} from '@angular/material/sort';
import {FilterItem} from '../../../../../domain/assistance/model/filterItem';
import {AssistanceService} from '../../../../../domain/assistance/service/assistance.service';
import {SalutationPipe} from '../../../../pipes/salutation.pipe';
import {User} from '../../../../../domain/core/model/user';
import {map} from 'rxjs/operators';
import {SafeSubscriberDirective} from '../../../../../application/app-context/safe-subscriber.directive';
import {ApplicationNamePipe} from '../../../../pipes/application-name.pipe';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {UserContext} from '../../../../../application/app-context/user-context/user-context';
import {Account} from '../../../../../domain/core/model/account';
import {ActivatedRoute} from '@angular/router';
import {App} from '../../../../../domain/core/model/app';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ConfigService} from '../../../../../application/config/config.service';
import {Assistance} from '../../../../../domain/assistance/model/assistance';
import {AssistanceDocument} from '../../../../../domain/assistance/model/assistance-document';
import {HomeAssistanceCreateRequestDialogComponent} from '../create-request-dialog/home-assistance-create-request-dialog.component';
import {AssistanceEventService} from '../../../../../domain/assistance/service/assistance-event.service';
import {AppAssistanceRequestType} from '../../../../../domain/core/model/app-assistance-request-type';
import {Colors} from '../../../../../domain/assistance/model/colors';
import {Solutions} from '../../../../../domain/core/model/solutions';
import {Status} from '../../../../../domain/assistance/model/status';
import {HomeAssistanceEditDialogComponent} from '../edit-dialog/home-assistance-edit-dialog.component';
import {HomeAssistanceDuplicateDialogComponent} from '../duplicate-dialog/home-assistance-duplicate-dialog.component';
import {HomeAssistanceDeleteDialogComponent} from '../delete-dialog/home-assistance-delete-dialog.component';
import {AnalyticsCategory} from '../../../../../application/analytics/analytics-category';
import {AnalyticsEventType} from '../../../../../application/analytics/analytics-event-type';
import {AmplitudeService} from '../../../../../application/analytics/service/amplitude.service';
import {LocalStorageKeyEnum} from '../../../../../application/app-context/local-storage-key.enum';
import {Role} from '../../../../../domain/core/model/role';

export interface AssistancesDialogData {
  selectedAssistance: Assistance;
  searchText: string;
  ticketId: number;
  selectedSolution: string;
}

@Component({
             templateUrl: './home-assistance-list-dialog.component.html',
             styleUrls: ['./home-assistance-list-dialog.component.scss']
           })
export class HomeAssistanceListDialogComponent extends SafeSubscriberDirective implements OnInit {

  solutions: Array<FilterItem> = [];
  sorted: Sort | undefined;

  categories = [
    {label: TypeAssistancesCategories.assistance, toggle: true, color: Colors.info},
    {label: TypeAssistancesCategories.update, toggle: true, color: Colors.info}
  ];

  importance = [
    {label: ImportanceCategories.high, toggle: true, color: Colors.info},
    {label: ImportanceCategories.average, toggle: true, color: Colors.info},
    {label: ImportanceCategories.low, toggle: true, color: Colors.info},
    {label: ImportanceCategories.unknown, toggle: true, color: Colors.info}
  ];

  listAssistances: Array<Assistance> = [];
  research = new FormControl('');
  idSelected: string | undefined;
  isCurrentlyUploadDocument = false;
  togglePanel: boolean | undefined;
  selectedAssistance: Assistance | undefined;
  toggleReadAssistances = true;
  currentUser: User | undefined;
  salutationPipe: SalutationPipe = new SalutationPipe();
  sortedData: Assistance[] | undefined;
  isConsultantOrIsDemo: boolean | undefined;
  isConsultantAndIsDemo: boolean | undefined;
  demoModeActivated: boolean | undefined;
  currentAccount: Account | undefined;
  userContext: UserContext | undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AssistancesDialogData,
              private userContextService: UserContextService,
              private assistanceService: AssistanceService,
              private assistanceEventService: AssistanceEventService,
              public matDialog: MatDialog,
              private configService: ConfigService,
              public translateService: TranslateService,
              private activatedRoute: ActivatedRoute,
              private amplitudeService: AmplitudeService,
              private applicationNamePipe: ApplicationNamePipe) {
    super();
    this.selectedAssistance = data.selectedAssistance;
    this.subs.push(this.research.valueChanges.subscribe(() => this.applyFilter()));
    this.research.patchValue(data.searchText, {emitEvent: false});
  }

  ngOnInit(): void {
    this.userContext = this.userContextService.getUserContext();
    this.isConsultantOrIsDemo = this.isConsultantOrIsDemoPlateform(this.userContext);
    this.demoModeActivated = localStorage.getItem(LocalStorageKeyEnum.DEMO_MODE) === 'on';
    this.isConsultantAndIsDemo = this.isConsultantAndIsDemoPlateform(this.userContext) || this.demoModeActivated;
    this.currentUser = this.userContext.user;
    this.currentAccount = this.userContext.getCurrentAccount();
    this.getSolutions();
    this.init();
  }

  onToggleRead(): void {
    this.toggleReadAssistances = true;
    this.applyFilter();
  }

  onToggleUnread(): void {
    this.toggleReadAssistances = false;
    this.applyFilter();
  }

  onSortData(sort: Sort): void {
    const data = this.sortedData.slice();
    if (sort) {
      this.sorted = sort;
      if (!sort.active || sort.direction === '') {
        this.sortedData = data;
        return;
      }
    } else {
      this.sortedData = data;
    }

    const isAsc = sort ? sort.direction === 'asc' : true;
    this.sortedData = data
      .sort((a: Assistance, b: Assistance) => compare(this.orderDate(a.creationDate), this.orderDate(b.creationDate), isAsc))
      .sort((a: Assistance, b: Assistance) => this.compareAssistance(sort, a, b, isAsc));
  }

  applyFilter(): void {
    this.sortedData =
      this.listAssistances
          .filter(assistance =>
                    this.filterSolutions(assistance) &&
                    this.filterCategories(assistance) &&
                    this.filterImportance(assistance) &&
                    this.filterResearch(assistance) &&
                    this.filterRead(assistance));
  }

  onRemoveResearch(): void {
    this.research.setValue('');
    this.applyFilter();
  }

  onSendMail(assistance: Assistance): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Origine', 'Fiche assistance');
    eventProperties.set('Plateforme', this.applicationNamePipe.transform(assistance.solution));
    eventProperties.set('TypeDeDemande', assistance.category);
    this.amplitudeService.trackEventAction(AnalyticsCategory.assistance, AnalyticsEventType.contact, eventProperties);

    window.location.href =
      `mailto:${this.getSolutionForMail(assistance.solution.toLowerCase())}-${this.getRequestTypeForMail(assistance)}@financeactive.com?`
      + `subject='[${new Date().toLocaleDateString()}][idClient=${this.currentAccount?.accountId}][idPlateforme=${this.getSolutionIdForObject(
        assistance)}]`
      + `[${this.currentAccount?.name}][${this.salutationPipe.transform(this.currentUser?.salutation)} ${this.currentUser?.firstname} ${this.currentUser?.lastname}]`
      + `${this.getRequestTypeForObject(assistance)}`;

  }

  onOpenDocument(solution: string, document: AssistanceDocument): void {
    this.trackAssistanceTableEvent(true);
    // open document in another tab appelle rest
    window.open(this.assistanceService.openDocument(solution, document), '_blank');
  }


  private trackAssistanceTableEvent(isDownload: boolean): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('FiltreSolution', this.solutions.filter(s => s.toggle).map(s => s.label).join(', '));
    eventProperties.set('FiltreCategorie', this.categories.filter(s => s.toggle).map(s => s.label).join(', '));
    eventProperties.set('FiltreImportance', this.importance.filter(s => s.toggle).map(s => s.label).join(', '));
    eventProperties.set('Tri', this.sorted ? this.sorted.active : 'aucun');
    eventProperties.set('Action', isDownload ? 'Telechargement' : 'Lecture');
    this.amplitudeService.trackEventAction(AnalyticsCategory.assistance, AnalyticsEventType.table, eventProperties);
  }

  onToggleView(id: string | undefined): void {
    if (this.idSelected === id) {
      this.idSelected = '0';
      this.selectedAssistance = undefined;
      this.onClosePanel();
    } else {
      this.selectedAssistance = this.listAssistances.find(assistance => assistance.id?.toString() === id);
      this.markAssistanceAsRead(this.selectedAssistance);
      this.openPanel();
      this.idSelected = id;
    }
  }

  onCreateAssistance(): void {
    const dialogRef = this.matDialog.open(HomeAssistanceEditDialogComponent, {
      width: '800px',
      height: '270px'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.init();
    });
  }

  onEditAssistance(assistance: Assistance): void {
    const dialogRef = this.matDialog.open(HomeAssistanceEditDialogComponent, {
      data: {assistance},
      width: '800px',
      height: '270px'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.init();
      this.onClosePanel();
    });
  }

  onDuplicateAssistance(assistance: Assistance): void {
    this.matDialog.open(HomeAssistanceDuplicateDialogComponent, {
      width: '800px',
      height: '330px',
      data: {assistance}
    });
  }

  onDeleteAssistance(assistance: Assistance): void {
    const dialogRef = this.matDialog.open(HomeAssistanceDeleteDialogComponent, {
      width: '500px',
      height: '120px',
      data: {
        deleteTitle: this.translateService.instant('assistance.delete-request-title'),
        deleteMessage: this.translateService.instant('assistance.delete-request-description')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteAssistance(assistance);
      }
    });
  }

  onCreateDocumentForAssistance($event: any, assistance: Assistance): void {
    const file = $event.target.files[0] as File;
    if (assistance.id) {
      this.isCurrentlyUploadDocument = true;
      this.assistanceService.addDocument(file, assistance.id)
          .subscribe({
                       next: () => {
                         this.init();
                         this.isCurrentlyUploadDocument = false;
                       },
                       complete: () => this.onClosePanel()
                     });
    }
  }

  onDeleteDocumentForAssistance(assistance: Assistance, document: AssistanceDocument): void {
    const dialogRef = this.matDialog.open(HomeAssistanceDeleteDialogComponent, {
      width: '500px',
      height: '120px',
      data: {
        deleteTitle: 'Supprimer le document ?',
        deleteMessage: 'Ce document ne sera plus visible et sera supprimé définitivement'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteDocument(assistance, document);
      }
    });
  }

  onRequestAssistance(): void {
    this.matDialog.open(HomeAssistanceCreateRequestDialogComponent, {
      data: {
        origin: 'Tab assistance'
      },
      height: '100%',
      width: '360px',
      position: {
        right: '0'
      }
    });
  }

  onClosePanel(): void {
    this.togglePanel = false;
    this.idSelected = undefined;
  }


  getColorForStatus(status: string): string {
    switch (status) {
      case Status.doing:
        return Colors.warning;
      case Status.done:
        return Colors.success;
      case Status.waiting:
        return Colors.alert;
      default:
        return Colors.insito;
    }
  }

  getIconForStatus(status: string): string {
    switch (status) {
      case Status.doing:
        return 'cog';
      case Status.done:
        return 'check';
      case Status.waiting:
        return 'exclamation-triangle';
      default:
        return 'cog';
    }
  }

  getUnreadAssistanceCount(): number | undefined {
    return this.sortedData?.filter(assistance => !assistance.read).length;
  }


  private init(): void {
    this.assistanceService.getAssistances().pipe(
      map(assistances => {
        this.listAssistances = assistances.sort((a: Assistance, b: Assistance) => {
          return compare(this.orderDate(a.creationDate), this.orderDate(b.creationDate), true);
        });
        this.applyFilter();
      }))
        .subscribe(() => this.activatedRoute.queryParams.subscribe(params => {
          if (this.selectedAssistance !== undefined) {
            if (this.listAssistances.find(assistance => assistance.id?.toString() === this.selectedAssistance?.id?.toString())
                !== undefined) {
              this.selectedAssistance = this.listAssistances.find(assistance => assistance.id?.toString()
                                                                                === this.selectedAssistance?.id?.toString());
              this.openPanel();
              this.idSelected = this.selectedAssistance?.id?.toString();
            }
            this.markAssistanceAsRead(this.selectedAssistance);
          }
          if (params.unread === 'true') {
            this.onToggleRead();
          }
          if (this.data.ticketId) {
            this.onToggleView(this.data.ticketId.toString());
          }
        }));
  }

  private getRequestTypeForObject(assistance: Assistance): string {
    return this.translateService.instant('assistance.ask-assistance-comment-on', {type: assistance.category, label: assistance.label});
  }

  private orderImportance(importance: string): number {
    switch (importance) {
      case ImportanceCategories.high:
        return 0;
      case ImportanceCategories.average:
        return 1;
      case ImportanceCategories.low:
        return 2;
      default : //  ImportanceCategories.unknown:
        return 3;
    }
  }

  private getSolutions(): void {
    this.solutions = [];
    this.currentAccount?.applications.forEach(app => {
      if (app.hasAccess) {
        const item: FilterItem = new FilterItem();
        const byLabel = App.getByLabel(app.applicationName);
        if (byLabel !== undefined) {
          item.label = new ApplicationNamePipe().transform(byLabel.key);
          item.color = Colors.info;

          if (this.data.selectedSolution) {
            item.toggle = this.data.selectedSolution === app.targetApp;
          } else {
            item.toggle = true;
          }

          this.solutions.push(item);
        }
      }
    });
  }

  private isConsultantOrIsDemoPlateform(userContext: UserContext | undefined): boolean {
    return Role.isConsultant(userContext?.user.role) || (this.configService?.config !== undefined && this.configService.config.isDemoEnabled);
  }

  private isConsultantAndIsDemoPlateform(userContext: UserContext | undefined): boolean {
    return Role.isConsultant(userContext?.user.role) && (this.configService?.config
           !== undefined
           && this.configService.config.isAskingAssistanceEnabled
           && this.configService.config.isDemoEnabled);
  }

  private filterSolutions(assistance: Assistance): boolean {
    const find = this.solutions.find(
      solution => {
        return solution?.label?.toUpperCase().localeCompare(new ApplicationNamePipe().transform(assistance.solution).toUpperCase()) === 0;
      }
    );
    return find !== undefined && find.toggle;
  }

  private filterCategories(assistance: Assistance): boolean {
    const find = this.categories.find(
      category => {
        return assistance.category.toUpperCase() === category.label.toUpperCase();
      }
    );
    return find !== undefined && find.toggle;
  }

  private filterImportance(assistance: Assistance): boolean {
    const find = this.importance.find(
      category => {
        return assistance.importance.toUpperCase() === category.label.toUpperCase();
      }
    );
    return find !== undefined && find.toggle;
  }

  private filterResearch(assistance: Assistance): boolean {
    return !this.research.value ||
           (assistance.label.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                      .indexOf(this.research.value.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >= 0);
  }

  private filterRead(assistance: Assistance): boolean {
    if (this.toggleReadAssistances) {
      return true;
    }
    return !assistance.read;
  }

  private orderAttached(documents: Array<AssistanceDocument>): number {
    if (documents && documents.length > 0) {
      return -1;
    }
    return 1;
  }

  private openPanel(): void {
    this.trackAssistanceTableEvent(false);
    this.togglePanel = true;
  }

  private deleteAssistance(assistance: Assistance): void {
    this.assistanceService.deleteAssistance(assistance)
        .subscribe(() => {
          this.init();
          this.onClosePanel();
          this.assistanceEventService.onChangeForAssistanceList.next();
        });
  }

  private deleteDocument(assistance: Assistance, document: AssistanceDocument): void {
    this.assistanceService.deleteDocument(assistance, document)
        .subscribe(() => {
          this.init();
          this.onClosePanel();
        });
  }

  private orderDate(date: Date): string {
    return (1 / new Date(date).getTime()).toString();
  }

  private orderStatus(status: string): number {
    switch (status) {
      case Status.waiting:
        return 0;
      case Status.doing:
        return 1;
      default : // Status.done
        return 2;
    }
  }

  private markAssistanceAsRead(selectedAssistance: Assistance | undefined): void {
    if (!selectedAssistance || selectedAssistance.read) {
      return;
    }
    selectedAssistance.read = true;
    this.assistanceService
        .markAssistanceAsRead(selectedAssistance)
        .subscribe(() => {
          this.listAssistances
              .filter(assistance => assistance.id === selectedAssistance.id)
              .forEach(assistance => assistance.read = true);
          this.assistanceEventService.onChangeForAssistanceList.next();
        });
  }

  private compareAssistance(sort: Sort, a: Assistance, b: Assistance, isAsc: boolean): number {
    switch (sort ? sort.active : 'date') {
      case 'statut':
        return compare(this.orderStatus(a.status), this.orderStatus(b.status), isAsc);
      case 'solution':
        return compare(a.solution, b.solution, isAsc);
      case 'date':
        return compare(this.orderDate(a.creationDate), this.orderDate(b.creationDate), isAsc);
      case 'categorie':
        return compare(a.category, b.category, isAsc);
      case 'importance':
        return compare(this.orderImportance(a.importance), this.orderImportance(b.importance), isAsc);
      case 'doc':
        return compare(this.orderAttached(a.documents), this.orderAttached(b.documents), isAsc);
      case 'label':
        return compare(a.label, b.label, isAsc);
      default:
        return 0;
    }
  }

  private getSolutionIdForObject(assistance: Assistance): string {
    if (assistance.solution === Solutions.insito) {
      return 'INSITO_J2EE';
    }
    return assistance.solution.toUpperCase();
  }


  private getRequestTypeForMail(assistance: Assistance): string {
    if (assistance.category === TypeAssistancesCategories.update) {
      return AppAssistanceRequestType.BACKOFFICE;
    } else {
      return AppAssistanceRequestType.CONSULTANT;
    }
  }

  private getSolutionForMail(solution: string): string {
    switch (solution) {
      case Solutions.alliance:
        return 'alliance';
      case Solutions.inviseo:
        return 'inviseo';
      case Solutions.fiscalite:
        return 'fiscalite';
      default:
        return 'insito';
    }
  }


}

function compare(a: number | string, b: number | string, isAsc: boolean): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

